module.exports = __webpack_public_path__ + "img/b583c34.png";